module.exports = __webpack_public_path__ + "img/Talent Boards.54ebedbb.svg";